module.exports = __webpack_public_path__ + "routes/urzad/szczegolyUrzedu/AdaMap.png?4df6f030";


//////////////////
// WEBPACK FOOTER
// ./routes/urzad/szczegolyUrzedu/AdaMap.png
// module id = 1831
// module chunks = 0